<div class="flex">
  <div class="flex-item">
    @if (dashboardService.loadingTravelDate || showLoader) {
      <div class="loading-div">
        @if (dashboardService.loadingTravelDate) {
          <mat-spinner diameter="80" class='full-center-spinner'></mat-spinner>
        }
      </div>
    }

    <div class="chart-container">
      @if (chartData) {
        <canvas baseChart
          [data]="chartData"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [type]="barChartType"
        ></canvas>
      }
    </div>
  </div>
</div>
